module.exports = __webpack_public_path__ + "media/images/webpage/shared/spotmap/location__restaurant--here-c241cdccbd5dda395a2e7dfa345da967.svg";